<template>
  <div>
    <QS-scroller-box>
      <!-- 企业租赁订单进来 展示特殊提示 -->
      <el-alert
        v-if="sourceType === 'enterpriseOrderChangeCar'"
        title="换车审批通过后，可在企业租赁子订单中查看到新订单信息，同时新老订单详情中展示关联关系"
        type="info"
        :closable="false"
      >
      </el-alert>
      <QS-h3-title title="审核详情" />
      <el-alert
        v-if="this.remark"
        class="reject-alert"
        :title="this.remark"
        type="error"
      />
      <!-- normalApprovalInfoShow  通用审批信息展示判断-->
      <div v-if="normalApprovalInfoShow">
        <QS-h4-title class="mt16" title="审核信息" />
        <div v-for="(approveItem, index) of approveDetail" :key="index">
          <span v-if="approveItem.type === 'tableTitle'" class="table-title">{{
            approveItem.label
          }}</span>
          <el-descriptions
            class="descriptions"
            v-if="approveItem.type === 'form'"
            :column="3"
            border
            size="medium"
          >
            <el-descriptions-item
              :labelStyle="{ 'min-width': '120px' }"
              :contentStyle="{ 'min-width': '200px' }"
              v-for="item in approveItem.data"
              :key="item.key"
              :label="item.label"
            >
              <span
                v-html="addLinkDoMain(item.value, item.label)"
                v-if="isDownFile(item.key, item)"
              ></span>
              <span v-html="valueMethod(item.value)" v-else></span>
            </el-descriptions-item>
          </el-descriptions>
          <div v-if="approveItem.type === 'photo'" class="flex">
            <span class="label mt16">{{ approveItem.data.label }}：</span>
            <show-img-and-file class="mt16" :list="approveItem.data.list" />
          </div>
          <QS-common-table
            class="mt16"
            v-if="approveItem.type === 'table'"
            :data="approveItem.data.list"
            :pagination="{}"
            :columns="approveItem.data.columns"
          />
        </div>
      </div>
      <div v-else>
        <maintenancePlanDetail />
      </div>
      <div slot="bottomAction" class="button-container">
        <el-button @click="cancel"> 取消 </el-button>
        <el-button @click="lookApprovalDetail" type="primary">
          查看审批动态
        </el-button>
        <el-button type="text" v-if="isExport">
          <export
            :exportTemplate="'ApprovalDetail'"
            filename="审批明细.xlsx"
            :params="exportParams"
            text="导出审批明细"
            type="primary"
          ></export>
        </el-button>
      </div>
    </QS-scroller-box>
    <!--  bizType 1 个人租赁应收审批 / 2租赁退车付款审批 / 3租赁退车收款审批 / 4支付宝支付解约 / 5网约钱包支付解约  -->
    <lookApprovalDetail ref="lookApprovalDetail" :id="$route.query.id" />
  </div>
</template>
<script>
import { detailInfo } from '@/api/domain/approvals'
import lookApprovalDetail from '@/pages/finance/batchCollectionRecord/components/lookApprovalDetail'
import maintenancePlanDetail from '@/pages/service/mainTenance/maintenancePlanDetail'

function isArrayJsonString(str) {
  try {
    JSON.parse(str) // 尝试将字符串解析为JSON对象或数组
    return true // 若能正常解析，说明是合法的JSON格式
  } catch (e) {
    return false // 若无法解析，说明不是合法的JSON格式
  }
}

export default {
  data() {
    return {
      remark: '',
      bizType: '',
      approveDetail: [],
      sourceType: '', // 来源类型  企业订单换车展示提示
    }
  },
  components: { lookApprovalDetail, maintenancePlanDetail },
  created() {
    const { id, bizId, bizType, sourceType } = this.$route.query
    this.sourceType = sourceType
    this.bizType = Number(bizType)
    detailInfo({
      id,
      bizId,
      bizType,
    }).then((res) => {
      if (res.code === 1) {
        const { formComponents = [], formParam = {}, taskVO = {} } = res.data
        let formData = {}
        formComponents.forEach((item) => {
          // 表格数据
          if (item.children) {
            // 遇到表格类型 当前表单结束
            // 把当前表单放进详情数据里
            Object.keys(formData).length > 0 &&
              this.approveDetail.push({
                type: 'form',
                data: formData,
              })
            formData = {}

            // 给表格加title
            this.approveDetail.push({
              type: 'tableTitle',
              label: item.props.label,
            })
            // 处理表格数据
            const tableData = {}
            tableData.columns = item.children.map((column) => {
              // 获取表格列
              const columnItem = {
                name: column.props.componentId,
                columnProps: {
                  prop: column.props.componentId,
                  label: column.props.label,
                },
              }
              // 渲染图片
              if (column.props.componentId === 'detailPhoto') {
                columnItem.render = ({ row }) => {
                  return (row.detailPhoto || []).map((img) => (
                    // eslint-disable-next-line no-undef
                    <EnlargeImg imgSrc={img} />
                  ))
                }
              }

              if (column.props.componentId === 'goodsLogo') {
                columnItem.render = ({ row }) => {
                  return (row.goodsLogo || []).map((img) => (
                    // eslint-disable-next-line no-undef
                    <EnlargeImg imgSrc={img} />
                  ))
                }
              }
              return columnItem
            })
            tableData.list = formParam[item.props.componentId]
            this.approveDetail.push({
              type: 'table',
              data: tableData,
            })
            return
          }
          // 图片类型
          if (item.componentType === 'DDPhotoField') {
            // 遇到图片类型 当前表单结束
            Object.keys(formData).length > 0 &&
              this.approveDetail.push({
                type: 'form',
                data: formData,
              })
            formData = {}
            // 处理图片数据
            const photoData = {}
            if (typeof formParam[item.props.componentId] === 'string') {
              photoData.list = this.getURL({
                data: formParam[item.props.componentId],
                needName: true,
              })
            }
            photoData.label = item.props.label
            this.approveDetail.push({
              type: 'photo',
              data: photoData,
            })
            return
          }
          // 文本类型
          formData[item.props.componentId] = {
            label: item.props.label,
            value: formParam[item.props.componentId],
            key: item.props.componentId,
            attachmentStatus: item.componentType === 'DDAttachment',
          }
        })

        // 最后结束是表单的情况
        if (Object.keys(formData).length > 0) {
          this.approveDetail.push({
            type: 'form',
            data: formData,
          })
        }
        if (taskVO && taskVO.state && [20, 30].includes(Number(taskVO.state))) {
          this.remark =
            Number(taskVO.state) === 20
              ? '审批撤回'
              : `审批驳回：${taskVO.remark || '--'}`
        }
      }
    })
  },
  methods: {
    // 查看审批动态
    lookApprovalDetail() {
      this.$refs.lookApprovalDetail.dialogVisible = true
    },
    cancel() {
      this.$refreshBack()
    },
    // value 兼容换行
    valueMethod(value) {
      if (!value) return '--'
      const result = value.toString().split('\n')
      if (result.length <= 1) return result[0] || value
      let str = ''
      result.forEach((ele) => {
        str += `<span>${ele}</span><br/>`
      })
      return str
    },
    // 链接添加域名
    addLinkDoMain(urlList, name = '附件明细') {
      if (!urlList) return '--'
      let urlArr = []
      if (isArrayJsonString(urlList)) {
        urlArr = JSON.parse(urlList)
      } else {
        urlArr.push(urlList)
      }
      let str = ''
      for (let i = 0; i < urlArr.length; i++) {
        const url = urlArr[i]
        const fileType = url.toString().slice(url.lastIndexOf('.')) // 截取文件格式
        const fileName = name + fileType // 文件名称+文件格式拼接
        const result = url.toString().match('cheweijia.com') // 判断是否携带域名
        const link = result ? url : window.location.origin + url || ''
        str += `<a href=${link} download=${fileName}>${fileName}</a>`
      }

      return str
    },
  },
  computed: {
    // 是否导出
    /**
     * bizType
     * key:value
     * 1-收款审批；2-租赁退车付款审批；3-租赁退车收款审批；4-支付宝支付解约；5-网约钱包支付解约；6-维保方案创建审批；
     * 7-维保方案终止审批；8-维保单创建审批；9-维保方案套餐新增；10-企业订单换车审批；11-应收金额调整；12-应收金额减免；
     * 13-强制收车；14-司机提车
     * * */
    isExport() {
      const { bizType } = this.$route.query
      // 审批业务类型：【收款审批】-钉钉审批+后台审批、【应收金额减免审批】、【应收金额调整审批】
      if (
        Number(bizType) === 1 ||
        Number(bizType) === 11 ||
        Number(bizType) === 12
      ) {
        return true
      }
      return false
    },
    // 导出参数
    exportParams() {
      const { id, bizId, bizType } = this.$route.query
      return { id, bizId, bizType }
    },
    isDownFile() {
      return function (data, item) {
        return item.attachmentStatus
      }
    },
    // 通用审批信息展示判断
    normalApprovalInfoShow() {
      /**
       * bizType:
       * 1:收款审批；
       * 2:租赁退车付款审批；
       * 3:租赁退车收款审批；
       * 4:支付宝支付解约；
       * 5:网约钱包支付解约；
       * 6:维保方案创建审批；
       * 7:维保方案终止审批；
       * 8:维保单创建审批；
       * 9:维保方案变更审批；
       * 10:企业订单换车审批;
       * 11应收调整；
       * 12金额减免
       * 13强收车；
       * 14提车；
       * 15:车辆调拨（调出）；
       * 16车辆调拨（调入)；
       * 17退车核算
       * 18新增应收单审批
       * 19"发起事故结算审批
       * 20"收款单作废审批"
       * 21"新增应付单审批
       * 22 "线下付款审批"
       * 23"应收金额调整审批
       * 24"付款单作废审批"
       * 25"采购订单退车核算审批"
       * 26 租赁订单线上签约
       *
       * */

      const { bizType } = this
      const _arr = [
        10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
        28, 29, 30, 31, 32, 33,
      ]
      return Number(bizType) < 6 || _arr.includes(Number(bizType))
    },
  },
}
</script>
<style scoped lang="scss">
.flex {
  display: flex;
  align-items: flex-start;
  .label {
    // width:100px;
  }
  .list {
    flex: 1;
  }
}

.descriptions {
  margin-top: 10px;
}
.file_item {
  width: 100%;
  color: #276bec;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  &:first-child {
    margin-top: 16px;
  }
}
.img_box {
  margin-bottom: 10px;
}
.table-title {
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  background: #f7f8fa;
  width: 100%;
  height: 38px;
  line-height: 38px;
  padding: 0 12px;
  color: #303133;
  margin: 10px 0;
}
</style>
